import React from 'react';
import type { FC } from 'react';

import type { TCalcWithModalDesktop } from '../models';

export const CalculatorWithModalDesktop: FC<TCalcWithModalDesktop> = ({
    ModalV2,
    ModalV2Content,
    ModalV2Header,
    children,
    isOpened,
    onClose,
    title,
}) => {
    return (
        <ModalV2 isOpen={isOpened} onClose={onClose}>
            <ModalV2Header title={title} />
            <ModalV2Content>{children}</ModalV2Content>
        </ModalV2>
    );
};
